export default {
  format(param) {
    if(param === null || param === undefined) {
      return '';
    }

    let date = new Date(param);
    const offsetMonth = date.getMonth() + 1;
    const month = offsetMonth.toString().padStart(2, "0");
    const day = date
      .getDate()
      .toString()
      .padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  },

  formatDateForStorage(param) {
    if(param === null || param === undefined) {
      return '';
    }

    let date = new Date(param);
    const offsetMonth = date.getMonth() + 1;
    const month = offsetMonth.toString().padStart(2, "0");
    const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day} 00:00:00.000`;
  },

  longMonth(dateString, options) {
    let date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      ...{ year: "numeric", month: "long", day: "numeric" },
      ...options
    });
  },

  toDateString(date) {
    return this.toUTCDate(date)
      .toISOString()
      .substring(0, 10);
  },

  usDateTime(date, options) {
    let local = new Date(date);
    return local.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      ...options
    });
  },

  /**
   * Adjusting for any timezone offsets
   */
  toUTCDate(date) {
    if (! (date instanceof Date)) {
      throw new Error('Expecting a Date instance');
    }

    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }
};
